import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { generateOtpComponentRef } from './consts';

export default grapesjs.plugins.add('gjs-otp-generation-form', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'otp-generation-form',
    blocks: [generateOtpComponentRef],
    defaultStyle: true,
    labelTable: 'OTP Generation Form',
    labelOTPGenerationFormCategory: 'Forms',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
